import { Component, ElementRef, OnInit } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import dayjs from 'dayjs';

import { FreyaCommonModule } from '../../freya-common/freya-common.module';
import { OverviewTimelineActions } from '../../job/job-overview/overview-timeline/overview-timeline.actions';
import { overviewTimelineFeature } from '../../job/job-overview/overview-timeline/overview-timeline.feature';
import { selectTimelineHighlightDates } from '../../job/job-overview/overview-timeline/overview-timeline.selectors';
import { HighlightDatesDirective } from '../directives/highlight-dates.directive';

@Component({
    selector: 'app-availability-schedule',
    standalone: true,
    imports: [
        FreyaCommonModule,
        HighlightDatesDirective,
    ],
    templateUrl: './availability-schedule.component.html',
    styleUrl: './availability-schedule.component.scss',
})
export class AvailabilityScheduleComponent implements OnInit {

    viewModel$ = this.store.select(createSelector({
        timeline: createSelector(
            overviewTimelineFeature.selectTimeline,
            (timeline) => timeline.map((dateStr) => dayjs(dateStr).toDate()),
        ),
        highlightDates: selectTimelineHighlightDates,
        dateRemarks: createSelector(
            overviewTimelineFeature.selectViewDatesMap,
            overviewTimelineFeature.selectTimeline,
            (viewDatesMap, timeline) => {
                const timelineSet = new Set<string>();
                if (timeline.length >= 2) {
                    let current = dayjs(timeline[0]);
                    const end = dayjs(timeline[timeline.length - 1]);
                    while (!current.isAfter(end)) {
                        timelineSet.add(current.format('YYYY-MM-DD'));
                        current = current.add(1, 'day');
                    }
                } else {
                    timeline.forEach((d) => timelineSet.add(d));
                }
                return Object.values(viewDatesMap)
                    .filter((d) => (d.remarks ?? []).some((r) => (r?.text ?? '').trim().length > 0) && timelineSet.has(d.date))
                    .flatMap((d) => (d.remarks ?? [])
                        .filter((r) => (r?.text ?? '').trim().length > 0)
                        .map((r) => ({
                            date: d.date,
                            text: r.text.trim(),
                            severity: r.severity || 'info',
                        })));
            },
        ),
    }));

    public actions = OverviewTimelineActions;

    constructor(
        public store: Store,
        public el: ElementRef,
    ) {}

    ngOnInit(): void {
      this.store.dispatch(this.actions.availabilityScheduledInitialized());
    }

    getTimeline(dates:Date[]) {
      return dates
        .filter(Boolean)
        .map((d) => dayjs(d).format('YYYY-MM-DD'));
    }
}
